// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"642":"940c3aa4","688":"badf541d","9599":"c132bf7d"}[chunkId] || chunkId) + "." + {"642":"5828aa36a961b7c2","688":"ae730edced3cf794","1592":"23051a2f333986e9","3621":"e2edee80bc19385c","9599":"f9ccf15d872e0d6f","9832":"6f4709f733a00c1b"}[chunkId] + ".js";
};